var exports = {
  "p_": "InvoiceList.module__list___UWp5Uk",
  "wx": "InvoiceList.module__header___UWp5Uk",
  "nM": "InvoiceList.module__row___UWp5Uk",
  "p6": "InvoiceList.module__date___UWp5Uk",
  "vj": "InvoiceList.module__amount___UWp5Uk",
  "Ie": "InvoiceList.module__empty___UWp5Uk",
};

module.exports = exports;
